export const selector = 'dbACompileComponent';

/* @ngInject */
export default function CompileComponentDirective($compile, stringUtil) {
    return {
        restrict: 'A',
        scope: {
            [selector]: '<',
            bindings: '='
        },
        
        link: (scope, element) => {
            compile(scope[selector], scope.bindings);

            function compile(component, bindings) {
                component = stringUtil.toSnakeCase(component || '');
                
                let link = $compile(`<${component} ${createBindings(bindings)}></${component}>`);

                element.html('');
                element.append(link(scope));
            }

            function createBindings(bindings) {
                return Object.keys(bindings)
                    .map((key) => {
                        return createBindingValue(key, key, bindings[key]);
                    })
                    .join(' ');
            }

            function createBindingValue(attribute, value, bindedValue) {
                if (typeof bindedValue === 'function') {
                    value = `${value}(data)`;
                }

                return bindAttributeOnModalInstance(stringUtil.toSnakeCase(attribute), value);
            }

            function bindAttributeOnModalInstance(attribute, value) {
                return `data-${attribute}="bindings.${value}"`;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/compile-component/compile-component.directive.js